/* eslint-disable react-hooks/exhaustive-deps */
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import routes from "./routes";
import Loader from "./components/CommonComponents/Loader";
import { selectorLoader } from "./store/reducers/loader";
import { initGA } from "./analytics";
import { updateLoading } from "./store/reducers/loader";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.css";
import "@fontsource/lexend";

function App() {
  const isLoading = useSelector(selectorLoader);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateLoading(false));
  }, []);

  useEffect(() => {
    initGA();
  }, []);
  return (
    <>
      {isLoading && <Loader />}
      <RouterProvider router={routes} />
      <ToastContainer />
    </>
  );
}

export default App;
